import { render, staticRenderFns } from "./SpecDropdown.vue?vue&type=template&id=e12ab54c&"
import script from "./SpecDropdown.vue?vue&type=script&lang=js&"
export * from "./SpecDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports